import classNames from 'classnames';
import React, { FC, PropsWithChildren, ReactNode } from 'react';

type className = Pick<React.HtmlHTMLAttributes<HTMLDivElement>, 'className'>;

const Container: FC<PropsWithChildren<{ header?: ReactNode } & className>> = ({ header, children, className }) => (
    <div className={classNames('container__standard-width', className)}>
        <div className="info-container">
            {header}
            <article className="card link-cards-container ">
                <div className="component-group">{children}</div>
            </article>
        </div>
    </div>
);
export default Container;
